import React from 'react';
import PropTypes from 'prop-types';
import { fieldWrapperStyle, requiredStyle } from './styles';

const FieldWrapper = ({ children, isEditing, required, title, tooltip }) => (
  <div css={fieldWrapperStyle}>
    <h3>{title}</h3>
    {required && isEditing && <span css={requiredStyle}>*</span>}
    {tooltip && <div className="tooltip-wrapper">{tooltip}</div>}
    {isEditing ? children : <p>{children}</p>}
  </div>
);

FieldWrapper.propTypes = {
  children: PropTypes.any.isRequired,
  isEditing: PropTypes.bool,
  required: PropTypes.bool,
  title: PropTypes.string,
  tooltip: PropTypes.element,
};

FieldWrapper.defaultProps = {
  isEditing: false,
  required: false,
  title: undefined,
  tooltip: undefined,
};

export default FieldWrapper;
